import React, { Dispatch, SetStateAction } from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { Drawer } from "antd";

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const CaptureTipDrawer = ({ open, setOpen }: Props) => {
  const theme = useTheme();

  return (
    <DrawerContainer
      title={<GrayBar />}
      width={"100%"}
      closable={false}
      height="auto"
      placement="bottom"
      open={open}
      onClose={() => setOpen(false)}>
      <Container>
        <TitleBox>
          <span>{"이렇게 촬영해주세요!"}</span>
        </TitleBox>

        <StepWrapper>
          <StepTitle>{"1. 옷을 착용하지 않고 촬영해주세요."}</StepTitle>

          <ImageBox>
            <Image src={theme.image.tip_1_1} width="100%" height="100%" />

            <Image src={theme.image.tip_1_2} width="100%" height="100%" />

            <Image src={theme.image.tip_1_3} width="100%" height="100%" />
          </ImageBox>
        </StepWrapper>

        <StepWrapper>
          <StepTitle>{"2. 배경은 옷과 대비되는 색 위에 올려주세요."}</StepTitle>

          <ImageBox>
            <Image src={theme.image.tip_2_1} width="100%" height="100%" />

            <Image src={theme.image.tip_2_2} width="100%" height="100%" />

            <Image src={theme.image.tip_2_3} width="100%" height="100%" />
          </ImageBox>
        </StepWrapper>

        <StepWrapper>
          <StepTitle>{"3. 옷의 전체 사진을 촬영해주세요."}</StepTitle>

          <ImageBox>
            <Image src={theme.image.tip_3_1} width="100%" height="100%" />

            <Image src={theme.image.tip_3_2} width="100%" height="100%" />

            <Image src={theme.image.tip_3_3} width="100%" height="100%" />
          </ImageBox>
        </StepWrapper>
      </Container>
    </DrawerContainer>
  );
};

export default CaptureTipDrawer;

const GrayBar = styled.div(({ theme }) => ({
  width: "9.3rem",
  height: "7px",
  backgroundColor: theme.color.border_gray,
  borderRadius: "10px",
}));

const DrawerContainer = styled(Drawer)(({ theme }) => ({
  borderRadius: "10px 10px 0 0",
  fontFamily: "Pretendard ,Sans-serif",
  padding: "0 2rem",
  maxWidth: "560px",

  ".ant-drawer-header": {
    display: "flex",
    borderBottom: "none",
  },

  ".ant-drawer-title": {
    display: "flex",
    justifyContent: "center",
  },

  ".ant-drawer-body": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "0 0 4.8rem",
    maxHeight: "70vh",

    "::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "5rem",
});

const TitleBox = styled.div(({ theme }) => ({
  fontSize: "3rem",
  fontWeight: theme.fontWeight.bold,
  lineHeight: "3rem",
  margin: "3rem 0 0 0",
}));

const StepWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",

  ".ex": {
    color: theme.color.dark_gray,
    fontSize: "1.4rem",
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.bold,
    textAlign: "center",
  },
}));

const ImageBox = styled.div({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  // gap: "1rem",
});

const StepTitle = styled.div(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
}));
